import React, { useEffect, useState } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Link } from "react-router-dom";
import bannerImage from "../../Images/academic/academic-philosophy-banner.webp";
import { Container, Spinner, Card, Button, Badge } from "react-bootstrap";

const AcademicSyllabus = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openYears, setOpenYears] = useState({});
  const [openFolders, setOpenFolders] = useState({});

  useEffect(() => {
    fetch("https://isbmuniversity.edu.in/admin-portal/get-syllabus")
      .then((res) => res.json())
      .then((res) => {
        setData(res);
        setLoading(false);
      });
  }, []);

  const toggleYear = (index) => {
    setOpenYears((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const toggleFolder = (key) => {
    setOpenFolders((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  // Recursive Renderer with Bootstrap Icons (using text) and Bootstrap classes
  const renderTree = (items, parentKey = "") => {
    return items.map((item, index) => {
      const uniqueKey = `${parentKey}-${index}`;

      if (item.type === "folder") {
        return (
          <div key={uniqueKey} className="mb-2">
            <div
              className="d-flex justify-content-between align-items-center p-2 rounded border cursor-pointer"
              onClick={() => toggleFolder(uniqueKey)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && toggleFolder(uniqueKey)}
            >
              <div className="d-flex align-items-center gap-2">
                <span className="fs-5">📁</span>
                <span className="fw-semibold text-dark">{item.name}</span>
                <Badge bg="secondary" className="ms-2 px-2 py-1 rounded-pill">
                  {item.children?.length || 0} items
                </Badge>
              </div>
              <span className="fs-5 fw-bold text-secondary">
                {openFolders[uniqueKey] ? "−" : "+"}
              </span>
            </div>

            {openFolders[uniqueKey] && (
              <div className="mt-2 ps-3 border-start border-2">
                {renderTree(item.children, uniqueKey)}
              </div>
            )}
          </div>
        );
      }

      return (
        <div key={uniqueKey} className="mb-1 p-1">
          <a
            href={encodeURI(item.url)}
            target="_blank"
            rel="noreferrer"
            className="text-decoration-none d-inline-flex align-items-center gap-2 text-primary-emphasis"
          >
            <span className="fs-6">📄</span>
            <span className="border-bottom border-primary border-opacity-25 pb-1">
              {item.name}
            </span>
          </a>
        </div>
      );
    });
  };

  return (
    <>
      <Topnav />

      {/* Hero Banner Section */}
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Academic Syllabus</h1>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="py-5">
        <div className="container-xxl">
          <div className="text-center mb-5">
            <h2 className="text-blue modern-title section-title">
              Academic Syllabus
            </h2>
            <p className="lead">
              Access comprehensive syllabus for all programs across different
              schools
            </p>
          </div>

          {loading ? (
            <div className="text-center py-5">
              <Spinner animation="border" variant="primary" className="me-2" />
              <span className="text-secondary-emphasis">
                Loading syllabus...
              </span>
            </div>
          ) : data.length > 0 ? (
            <div className="row justify-content-center">
              <div className="col-lg-10">
                {data.map((yearItem, yIndex) => (
                  <Card
                    key={yIndex}
                    className="mb-4 shadow border-0 rounded-4 overflow-hidden"
                  >
                    <Card.Header
                      className="bg-white border-bottom p-0 cursor-pointer"
                      role="button"
                      onClick={() => toggleYear(yIndex)}
                      tabIndex={0}
                      onKeyDown={(e) => e.key === "Enter" && toggleYear(yIndex)}
                    >
                      <div className="d-flex justify-content-between align-items-center p-3">
                        <div className="d-flex align-items-center gap-3">
                          <span className="fs-3">🎓</span>
                          <div>
                            <h3 className="h5 fw-bold text-dark mb-0">
                              {yearItem.year}
                            </h3>
                          </div>
                        </div>
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          className="rounded-circle p-0 d-flex align-items-center justify-content-center"
                          style={{ width: "32px", height: "32px" }}
                        >
                          {openYears[yIndex] ? "−" : "+"}
                        </Button>
                      </div>
                    </Card.Header>

                    {openYears[yIndex] && (
                      <Card.Body className="bg-opacity-50 p-4 border-top">
                        {renderTree(yearItem.children, yIndex)}
                      </Card.Body>
                    )}
                  </Card>
                ))}
              </div>
            </div>
          ) : (
            <div className="text-center py-5 bg-white rounded-4 shadow-sm">
              <div className="fs-1 mb-3">📭</div>
              <h4 className="h5 text-secondary">No syllabus data available</h4>
              <p className="small text-secondary-emphasis">
                Please check back later for updated syllabus information.
              </p>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </>
  );
};

export default AcademicSyllabus;
